import { useEffect } from "react";

interface TitleSetterProps {
  title: string;
  children: React.ReactNode;
}

const TitleSetter: React.FC<TitleSetterProps> = ({ title, children }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return <>{children}</>;
};

export default TitleSetter;